/** Formats français (UX-28) : dates 14/10/2026, montants 18 450 €, durées et tailles lisibles. */
const FUSEAU = 'America/Guadeloupe';

const FORMAT_DATE = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: FUSEAU });

export const formaterDate = (date: Date): string => FORMAT_DATE.format(date);

const FORMAT_ENTIER = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
const FORMAT_CENTIMES = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formaterMontant = (montant: number): string => (Number.isInteger(montant) ? FORMAT_ENTIER : FORMAT_CENTIMES).format(montant);

const deuxChiffres = (n: number): string => String(n).padStart(2, '0');

export function formaterDuree(secondes: number): string {
  const total = Math.max(0, Math.round(secondes));
  return `${Math.floor(total / 60)} min ${deuxChiffres(total % 60)} s`;
}

const FORMAT_UNE_DECIMALE = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });

export function formaterTaille(octets: number): string {
  const ko = octets / 1024;
  if (ko < 1024) return `${Math.max(1, Math.round(ko))} Ko`;
  return `${FORMAT_UNE_DECIMALE.format(ko / 1024)} Mo`;
}
